import React from 'react';
import '../Styles/Footer.css';
import { trackWhatsApp } from '../utils/Tracking';

import logo from '../Resources/salalogo1.webp'
import krushikalogo from '../Resources/krushika.png'

export default function SalaFooter() {
  return (
    <footer className="sala-footer-container">
      <div className="sala-footer-top">
        <div className="sala-footer-brand">
          <div className="sala-footer-logo-container">
            <img src={logo} className="sala-footer-logo" alt="The Sala Logo"></img>
            <a href="https://krushika.org/" target="_blank" rel="noopener noreferrer">
              <img src={krushikalogo} className="sala-footer-logo" alt="Krushika Logo"></img>
            </a>
          </div>
          <p className="sala-footer-description">
            Redefining architecture with elegance and timeless design.
          </p>
        </div>
        <div className="sala-footer-links">
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4>Follow Us</h4>
            <ul>
              <li><a href='https://www.instagram.com/the_sala_resort/'>Instagram</a></li>
              <li><a href='https://api.whatsapp.com/send/?phone=9986800600&text=test&type=phone_number&app_absent=0' onClick={() => trackWhatsApp()}>Whatsapp</a></li>
              <li><a href='https://www.facebook.com/thesalaresort/'>Facebook</a> </li>
            </ul>
          </div>
          <div>
            <h4>Resources</h4>
            <ul>
              <li><a href="#!">Privacy Policy</a></li>
              <li><a href="#!">Terms of Service</a></li>
              <li><a href="#!">FAQ</a></li>
            </ul>
          </div>

        </div>
      </div>

      <div className="sala-footer-bottom">
        <p>Copyright © <a href="https://tloomy.com" target="_blank" rel="noopener noreferrer">Tloomy</a>. All rights reserved.</p>
      </div>
    </footer>
  );
}
